import { Injectable } from '@angular/core';
import { OptionAutomatique } from '@lib/models/generated/graphql';
import { gql } from 'apollo-angular';
import { QueryManagerService } from 'finzzle-angular-utils';
import _ from 'lodash';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
export const OPTIONAUTOS_BY_PRODUIT = gql`
  query optionsAutomatiquesByProduit($produitId: Long!) {
    optionsAutomatiquesByProduit(produitId: $produitId) {
      id
      libelle
      ordre
      modeDeGestionCode
    }
  }
`;
@Injectable({
  providedIn: 'root',
})
export class OptionAutomatiqueService {
  private options: OptionAutomatique[] = [];
  public currentOptionAutomatiqueSubject = new BehaviorSubject<OptionAutomatique | null>(null);

  reset() {
    this.currentOptionAutomatiqueSubject.next(null);
  }

  setOptionAutomatique(option: OptionAutomatique | null) {
    this.currentOptionAutomatiqueSubject.next(option);
  }

  constructor(private queryManager: QueryManagerService) {}

  async loadOptionsAutomatiquesByProduit(produitId: number | null): Promise<void> {
    if (produitId === null || isNaN(produitId)) {
      this.options = [];
      return;
    }
    const { data } = await lastValueFrom(
      this.queryManager.query<{ optionsAutomatiquesByProduit: OptionAutomatique[] }>({
        query: OPTIONAUTOS_BY_PRODUIT,
        variables: { produitId },
      })
    );

    this.options = data?.optionsAutomatiquesByProduit ?? [];
  }

  public get optionsAutomatiques(): OptionAutomatique[] {
    return this.options;
  }

  public get optionsAutomatiquesByModeGestionCode(): Record<string, OptionAutomatique[]> {
    return _.groupBy(this.options, 'modeDeGestionCode');
  }

  public getOptionAutomatiqueByModeGestion(gestionCode: string): OptionAutomatique[] {
    return this.optionsAutomatiquesByModeGestionCode[gestionCode] ?? [];
  }
}
